module.exports = __webpack_public_path__ + "static/media/AB_L31_7.36937c4e.jpg";